import {
  EntityList,
  EntityListNavigationType,
  SVGIconComponent,
  useInMemoryFilteredList
} from '@hevoio/hevo-ui-toolkit';

import { ConnectivityTable } from './components/ConnectivityTable';
import { CreateVPCPeeringButton } from './components/CreateVPCPeeringButton';
import { useRef, useState } from 'react';
import { CreateVPCModal } from './components/CreateVPCModal/CreateVPCModal';
import TeamAPI from '../api/TeamAPI';
import { VPCPeeringConnection } from './interface';
import { IconNetwork } from '@tabler/icons-react';
import { RbacPermissions } from '../../../core/interfaces/user';
import useHasPermission from '../../../access-control/hooks/useHasPermission';
import useUserService from '../../../auth/hooks/useUserService';

export const Connectivity = () => {
  const [openCreateVPCModal, setOpenCreateVPCModal] = useState(false);
  const { user } = useUserService();
  const entityListRef = useRef<{ reset: () => void }>();
  const { fetch, reset } = useInMemoryFilteredList<VPCPeeringConnection>(
    () =>
      TeamAPI.getConnectivityPeeringList(user.teamId).then(
        (res: { total_count: number; data: VPCPeeringConnection[] }) => res.data
      ),
    () => true
  );

  const { hasPermission } = useHasPermission();

  const refreshList = () => {
    reset();
    entityListRef.current?.reset();
  };

  return (
    <>
      <CreateVPCModal
        open={openCreateVPCModal}
        onClose={() => setOpenCreateVPCModal(false)}
        onSuccess={refreshList}
      />
      <EntityList
        innerRef={entityListRef}
        onRefresh={() => reset()}
        mode={'standalone'}
        flat
        entityTitle='VPC Peering Connections'
        navigationType={EntityListNavigationType.INFINITE_SCROLL}
        newListSVGIcon={IconNetwork as unknown as SVGIconComponent}
        newListConnectedTitle={'Set up a VPC Peering connection'}
        newListConnectedSubTitle='A VPC Peering connection establishes a private network connection between your AWS Source or Destination database and Hevo, enabling secure access without exposing the database to the public internet.'
        newListComponentProps={{
          primaryCTAProps: {
            dataId: 'create-vpc-peering',
            icon: 'plus',
            className: 'px-3 py-2',
            disabled: !hasPermission(RbacPermissions.PIPELINE_CREATE),
            onClick: () => {
              setOpenCreateVPCModal(true);
            },
            size: 'md',
            children: <>Create VPC Peering</>
          }
        }}
        genericErrorTitle={''}
        genericErrorSubTitle={''}
        ListComponent={ConnectivityTable}
        shimmerColumnsCount={7}
        emptyTitle={''}
        emptySubTitle={''}
        hidePagination
        dataSource$={fetch}
        entity={'vpc-connections'}
        StandaloneModeActions={() => (
          <CreateVPCPeeringButton
            onClick={() => {
              setOpenCreateVPCModal(true);
            }}
          />
        )}
      />
    </>
  );
};
